import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { DeviceState } from './types';

export const deviceStatesApi = createApi({
  reducerPath: 'deviceStatesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/device-states`,
  }),
  tagTypes: ['MeteringDeviceAction'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getDeviceStates: builder.query<DeviceState[], void>({
      query: () => ({
        url: '',
      }),
    }),
  }),
});

export const { useGetDeviceStatesQuery } = deviceStatesApi;
